





























import Vue from "vue";

export default Vue.extend<{}, {}, {}, Props>({
  props: {
    isChecked: {
      type: Boolean,
      default: false,
    },
    iconSize: {
      type: Number,
      default: 24,
    },
    fill: {
      type: String,
      default: "#d0d0d0",
    },
  },
});

interface Props {
  isChecked: boolean;
  iconSize: number;
  fill: string;
}
